import React, {useEffect, useState} from 'react';

import moment from "moment";

import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Dot, DotGroup } from 'pure-react-carousel';

import {default as renderDots} from './Pagination';

import 'pure-react-carousel/dist/react-carousel.es.css';

import {filterAthletes} from "../helper";

import axios from "axios";

function Leaderboard (props) {

    const [efforts, setEfforts] = useState([]);

    const [slides, setSlides] = useState([]);

    const [filtered, setFiltered] = useState([]);

    const perPage = 25;

    const {
        segment,
        gender,
    } = props;

    useEffect(() => {

        axios.get(`/api/segments/${segment}/efforts?gender=${gender}`)
            .then(result => setEfforts(result.data));

    }, []);

    useEffect(() => {

        const searchArray = props.searchString.toLowerCase().split(',');

        const f = efforts.filter((effort) => filterAthletes(effort.athlete.fullname, searchArray))//.sort((a, b) => b.points - a.points);

        const s = [];

        for (let i = 0; i < f.length/perPage; i++) {

            s.push(i);

        }

        setSlides(s);

        setFiltered(f);

    }, [efforts, props.searchString]);

    if (efforts.length > 0) return (
        <div>

            <div className="d-flex align-items-center">
                <h3 className={'mr-3'}>{props.gender === 'M' ? 'Buaba' : 'Mädla'}</h3>
                <span className={'mr-auto'}>{efforts.length} gesamt</span>
                <span className={'mr-3 text-light'}><small>Stand von {moment(efforts[0].updated_at).format('ddd H:mm')} Uhr</small></span>
            </div>

            <table className={'table mb-0'}>

                <thead>
                    <tr>
                        <th className={'w-12'}></th>
                        <th className={'w-50'}>Name</th>
                        <th className={'w-12'}>Zeit</th>
                        <th className={'w-25'}>Punkte</th>
                    </tr>
                </thead>

            </table>

            <CarouselProvider
                naturalSlideWidth={100}
                naturalSlideHeight={200}
                totalSlides={slides.length}
                isIntrinsicHeight={true}
            >
                <Slider>

                    {slides.map((slide, i) => {

                        return <Slide index={i} key={i}>
                            <table className={'table'}>

                                <thead style={{visibility: 'collapse'}}>
                                <tr>
                                    <th className={'w-12'}></th>
                                    <th className={'w-50'}>Name</th>
                                    <th className={'w-12'}>Zeit</th>
                                    <th className={'w-25'}>Punkte</th>
                                </tr>
                                </thead>

                                <tbody>
                                {filtered.slice(slide*perPage, (slide+1)*perPage).map((effort, i) => (
                                    <tr key={i}>
                                        <td>{effort.rank}</td>
                                        <td><a href={`//strava.com/activities/${effort.activity_id}`} target={'_blank'}>{effort.athlete.fullname}</a></td>
                                        <td>{moment.utc(moment.duration(parseInt(effort.elapsed_time), 'seconds').asMilliseconds()).format("mm:ss")}</td>
                                        <td>{effort.points}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </Slide>
                    })}
                </Slider>

                <DotGroup renderDots={renderDots}></DotGroup>

            </CarouselProvider>

        </div>
    );

    return (
        <div>No efforts</div>
    )
}

export default Leaderboard;
